// extracted by mini-css-extract-plugin
export default {"infoForm":"MandatoryFieldsFrom_infoForm__knPTx","formGroup":"MandatoryFieldsFrom_formGroup__P+XfP","ageMessage":"MandatoryFieldsFrom_ageMessage__ykeQG"};